import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { Images } from '~data'
import Promo from './style'
 
export default function PromoSection({...rest}){
return(
<Promo backgroundColor="#5034fc">
  <Container>
    <Row className="justify-content-center text-center">
      <Col className="col-xl-8">
        <Promo.Content>
          <Promo.Title fontColor="#fff" as="h2" mb="45px">Хотите присоединиться к нам? </Promo.Title>
          <a href="https://t.me/nextgen_admin"><Promo.Button background="#ff5722">Отправьте резюме</Promo.Button></a>
        </Promo.Content>
      </Col>
    </Row>
  </Container>
  <Promo.Shape>
    <img className="w-100" src={Images.PageAboutUs.InnerPromoShape} alt="inner shape" />
  </Promo.Shape>
</Promo>

)
}